import { QueryClient } from "@tanstack/react-query";

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      refetchOnWindowFocus: false, // 다른 브라우저 갔다가 돌아왔을 때 다시 조회할 지 여부
      throwOnError: true,
    },
    mutations: {
      throwOnError: false,
      // onError: (error: any) => {
      //   console.log(`[${error.code}] ${error.message}`);
      // },
    },
  },
});
